import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { BtcTitle, MyBtcLayout } from "./BtcAdmin";

import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getAllBtcDk } from "../../services/btc/btcApi";
import { useSelector } from "react-redux";
import { selectGrp } from "../../features/auth/authSlice";

import SearchIcon from "@mui/icons-material/Search";
import { Tooltip } from "@mui/material";
import html2canvas from "html2canvas";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export default function ReportPage({ navigate, params = {} }) {
  const [data, setData] = useState(() => {
    return []
    // const data = [
    //   {
    //     ngay: "2026-04-01",
    //     amount: "50000",
    //     note: "お布施",
    //   },
    //   {
    //     ngay: "2026-04-02",
    //     amount: "-20000",
    //     note: "修繕費",
    //   },
    // ];
    // const repeatedData = Array.from({ length: 100 }, () =>
    //   data.map((row) => ({ ...row })),
    // ).flat();
    // return repeatedData;
  });
  const [form, setForm] = useState({
    ngay: "",
    amount: "",
    note: "",
  });

  const { startDate: defaultStartDate, endDate: defaultEndDate } = getJapanFiscalYearRange();
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    if (!form.ngay || !form.amount) return;

    setData((prev) => [
      ...prev,
      {
        ngay: form.ngay,
        amount: Number(form.amount),
        note: form.note,
      },
    ]);

    setForm({ ngay: "", amount: "", note: "" });
  };

  const summary = useMemo(() => {
    let thu = 0;
    let chi = 0;

    data.forEach((item) => {
      if (item.amount > 0) thu += parseInt(item.amount);
      if (item.amount < 0) chi += Math.abs(item.amount);
    });

    return {
      thu,
      chi,
      du: thu - chi,
    };
  }, [data]);

  const handleExportCsv = () => {
    if (!data.length) return;

    const headers = [
      "日付",
      "摘要",
      "借方科目",
      "借方金額",
      "貸方科目",
      "貸方金額",
    ];

    const rows = data.map((item) => {
      if (item.amount > 0) {
        // Thu
        return [
          item.ngay,
          item.note || "",
          "現金",
          item.amount,
          "収入",
          item.amount,
        ];
      }
      // Chi
      return [
        item.ngay,
        item.note || "",
        "支出",
        Math.abs(item.amount),
        "現金",
        Math.abs(item.amount),
      ];
    });

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((cell) =>
            typeof cell === "string" ? `"${cell.replace(/"/g, '""')}"` : cell,
          )
          .join(","),
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "report_仕訳帳.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const grp = useSelector(selectGrp);
  const handleSearch = async () => {
    setLoading(true);
    try {
      const { result } = await getAllBtcDk({
        start: startDate,
        end: endDate,
        grp,
      });
      const data = [];
      result.forEach(({ ngay, note, dsQuy, deleted, flag }) => {
        if (deleted || flag) {
          return; //skip delete or admin
        }

        var total = 0;
        dsQuy.forEach((dk) => {
          if (dk.donVi === "y") {
            total += dk.soLuong;
          }
        });
        data.push({ ngay, note, amount: total });
      });
      setData(data);
    } catch (err) {
      console.error("Search error", err);
    } finally {
      setLoading(false);
    }
  };

  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const footer = (
    <Stack direction={"row"} spacing={1}>
      <Button variant="outlined" onClick={handleExportCsv}>
        Export CSV
      </Button>

      <Button variant="outlined" onClick={() => setOpen(true)}>
        Preview / Print
      </Button>
    </Stack>
  );
  return (
    <MyBtcLayout title={title} footer={footer}>
      <Box
        p={{ xs: 1, sm: 2 }}
        display={"flex"}
        height={"100%"}
        flexDirection={"column"}
      >
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} mb={1}>
          <Typography variant="h5">Report</Typography>

          <Box display="flex" gap={1} mb={2} alignItems="center">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Từ ngày"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={dayjs(startDate)}
                onChange={(newValue) => {
                  setStartDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                }}
                format="DD/MM/YYYY" // ✅ dd/MM/yyyy
              />

              <DatePicker
                label="Đến ngày"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={dayjs(endDate)}
                onChange={(newValue) => {
                  setEndDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                }}
                format="DD/MM/YYYY" // ✅ dd/MM/yyyy
              />
            </LocalizationProvider>

            <Tooltip title="Search">
              <span>
                <IconButton
                  color="primary"
                  onClick={handleSearch}
                  disabled={!startDate || !endDate || loading}
                >
                  <SearchIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Stack>

        {/* Form input */}
        {/* <Box display="flex" gap={2} mb={3}>
          <TextField
            type="date"
            name="ngay"
            size="small"
            value={form.ngay}
            onChange={handleChange}
          />
          <TextField
            type="number"
            name="amount"
            size="small"
            label="Amount (+ thu / - chi)"
            value={form.amount}
            onChange={handleChange}
          />
          <TextField
            name="note"
            size="small"
            label="Note"
            value={form.note}
            onChange={handleChange}
          />
          <Button variant="contained" onClick={handleAdd}>
            Add
          </Button>
        </Box> */}

        <Box sx={{ flexGrow: 1, overflow: "auto", minHeight: "40vh" }}>
          {/* Table */}
          <Paper>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Ngày</TableCell>
                  <TableCell>Note</TableCell>
                  <TableCell align="right">Thu</TableCell>
                  <TableCell align="right">Chi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.ngay}</TableCell>
                    <TableCell>{row.note}</TableCell>
                    <TableCell align="right">
                      {row.amount > 0
                        ? parseInt(row.amount).toLocaleString()
                        : ""}
                    </TableCell>
                    <TableCell align="right">
                      {row.amount < 0
                        ? Math.abs(row.amount).toLocaleString()
                        : ""}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Box>
        {/* Summary */}
        <Box mt={3}>
          <Typography>✅ Tổng thu: {summary.thu.toLocaleString()}</Typography>
          <Typography>❌ Tổng chi: {summary.chi.toLocaleString()}</Typography>
          <Typography fontWeight="bold">
            💰 Số dư: {summary.du.toLocaleString()}
          </Typography>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: "100vw",
            maxWidth: "100vw",
          },
        }}
      >
        <DialogTitle>
          <div className="no-print">
            仕訳帳 レポート
            <IconButton
              onClick={() => setOpen(false)}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <PrintArea data={data} />
        </DialogContent>
      </Dialog>
    </MyBtcLayout>
  );
}
function PrintArea2({ data }) {
  const [pageImages, setPageImages] = useState([]);
  const [loadingPreview, setLoadingPreview] = useState(false);

  const ROWS_PER_PAGE = 25;

  const chunkData = (data, size) => {
    const pages = [];
    for (let i = 0; i < data.length; i += size) {
      pages.push(data.slice(i, i + size));
    }
    return pages;
  };
  const chunks = chunkData(data, ROWS_PER_PAGE);
  console.log("Total rows:", data.length, "Pages:", chunks.length);

  useEffect(() => {
    const previewByPage = async () => {
      setLoadingPreview(true);
      const images = [];

      for (let i = 0; i < chunks.length; i++) {
        const el = document.getElementById(`print-page-${i}`);
        if (!el) continue;

        const canvas = await html2canvas(el, {
          scale: 2,
          backgroundColor: "#fff",
          useCORS: true,
        });

        images.push({
          page: i + 1,
          src: canvas.toDataURL("image/png"),
        });
      }

      setPageImages(images);
      setLoadingPreview(false);
    };

    previewByPage();
  }, [chunks.length]);

  return (
    <>
      {pageImages.length === 0 ? (
        <div>
          {chunks.map((pageData, pageIndex) => (
            <div
              key={pageIndex}
              id={`print-page-${pageIndex}`}
              className="print-page"
            >
              <h4 style={{ textAlign: "center" }}>
                仕訳帳（Page {pageIndex + 1} / {chunks.length}）
              </h4>

              <Table size="small" className="report-table">
                <TableHead>
                  <TableRow>
                    <TableCell>日付</TableCell>
                    <TableCell>摘要</TableCell>
                    <TableCell align="right">借方</TableCell>
                    <TableCell align="right">貸方</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {pageData.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>{row.ngay}</TableCell>
                      <TableCell>{row.note}</TableCell>
                      <TableCell align="right">
                        {row.amount > 0 ? row.amount.toLocaleString() : ""}
                      </TableCell>
                      <TableCell align="right">
                        {row.amount < 0
                          ? Math.abs(row.amount).toLocaleString()
                          : ""}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ))}
        </div>
      ) : (
        pageImages.map((img) => (
          <div key={img.page} style={{ marginBottom: 16 }}>
            <p>Page {img.page}</p>
            <img
              src={img.src}
              style={{ width: "100%", border: "1px solid #ccc" }}
            />
          </div>
        ))
      )}

      <Backdrop
        open={loadingPreview}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.modal + 1,
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
function PrintArea({ data }) {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-area">
      <Typography variant="h6" align="center" mb={2}>
        仕訳帳
      </Typography>

      {/* wrapper để scroll */}
      <div className="table-scroll">
        <Table stickyHeader size="small" className="report-table">
          <TableHead>
            <TableRow>
              <TableCell>日付</TableCell>
              <TableCell>摘要</TableCell>
              <TableCell align="right">借方科目</TableCell>
              <TableCell align="right">借方金額</TableCell>
              <TableCell align="right">貸方科目</TableCell>
              <TableCell align="right">貸方金額</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item, i) => {
              const isThu = item.amount > 0;
              const value = Math.abs(item.amount);

              return (
                <TableRow key={i}>
                  <TableCell>{item.ngay}</TableCell>
                  <TableCell>{item.note}</TableCell>
                  <TableCell align="right">{isThu ? "現金" : "支出"}</TableCell>
                  <TableCell align="right">{value.toLocaleString()}</TableCell>
                  <TableCell align="right">{isThu ? "収入" : "現金"}</TableCell>
                  <TableCell align="right">{value.toLocaleString()}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      <div className="no-print" style={{ textAlign: "right", marginTop: 16 }}>
        <Button variant="contained" onClick={handlePrint}>
          Print / PDF
        </Button>
      </div>
    </div>
  );
}

const getJapanFiscalYearRange = () => {
  // JST (UTC+9)
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" }),
  );

  const year = now.getFullYear();
  const month = now.getMonth() + 1; // 1–12

  let startYear;
  let endYear;

  // Trước ngày 1/4 → thuộc FY năm trước
  if (month < 4) {
    startYear = year - 1;
    endYear = year;
  } else {
    startYear = year;
    endYear = year + 1;
  }

  return {
    startDate: `${startYear}-04-01`,
    endDate: `${endYear}-03-31`,
  };
};
